import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=12a63d67"
import script from "./reject.vue?vue&type=script&lang=js"
export * from "./reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports